export default "__VITE_ASSET__DjoaddaB__"